module.exports = __webpack_public_path__ + "media/customizations/breezehome/logo-b815ea44aea5fc46f1697356f7582c30.png";